import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Search } from '../../../../shared/components/search/search';
import { Infraestructure } from '../../../../core/models/infraestructure.interface';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Title } from '@angular/platform-browser';
import { InfraestructureService } from '../../../../core/services/infraestructure/infraestructure-service';
import { PAGINATION } from '../../../../core/constants/constants';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { InfraestructureForm } from '../infraestructure-form/infraestructure-form';

@Component({
  selector: 'app-infraestructure-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search,
  ],
  templateUrl: './infraestructure-list.html',
  styleUrl: './infraestructure-list.scss',
})
export class InfraestructureList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  infraestructure: Infraestructure[] = [];
  asyncInfraestructures!: Observable<Infraestructure[]>;
  buscarinfraestructures: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = [
    'acciones',
    'id',
    'name',
    'type',
    'description',
    'status',
    'availability',
    'max_capacity',
    'location',
    'address',
  ];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private infraestructureService: InfraestructureService,
    private loadingService: LoadingService,
    private title: Title,
  ) {
    this.title.setTitle('Infraestructura');
  }

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchInfraestructure(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchInfraestructure(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncInfraestructures = this.infraestructureService.getInfraestructure(params).pipe(
      tap((data) => {
        this.infraestructure = data.results;
        this.infraestructureService.setInfraestructure(data.results[0]);
        this.infraestructureService.setInfraestructures(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createInfraestructure() {
    this.infraestructureService.removeInfraestructureSelected();
    const dialogRef = this.dialog.open(InfraestructureForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchInfraestructure(this.page);
    });
  }

  updateInfraestructure(infraestructure: Infraestructure) {
    this.infraestructureService.setInfraestructure(infraestructure);
    const dialogRef = this.dialog.open(InfraestructureForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchInfraestructure(this.page);
    });
  }

  eliminate(infraestructure: Infraestructure): void {
    const confirmed = window.confirm(
      `¿Estás seguro de eliminar el registro: ${infraestructure.name}?`,
    );
    if (!confirmed) return;
    this.infraestructureService.delete(infraestructure.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchInfraestructure(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
